module.exports = __webpack_public_path__ + "assets/moneycard-493287.svg";